// Background images for the landing/sign-in pages
// Stored locally in public/backgrounds/ for reliability

export const BACKGROUND_IMAGES = [
  // 1. Flour under baked bread — warm, dramatic, hands at work
  '/backgrounds/bg-flour-bread.jpg',

  // 2. Chopping green peppers on a cutting board — knife skills, action
  '/backgrounds/bg-chopping-peppers.jpg',

  // 3. Beautifully plated Italian dish — gourmet, elegant, fine dining
  '/backgrounds/bg-gourmet-plate.jpg',

  // 4. Steam rising from a pan on a gas stove — fire, heat, dynamic cooking
  '/backgrounds/bg-steam-stove.jpg',

  // 5. Colorful fresh fruits and vegetables at market stalls — vibrant, produce
  '/backgrounds/bg-colorful-market.jpg',
]

export function getRandomBackground(): string {
  const idx = Math.floor(Math.random() * BACKGROUND_IMAGES.length)
  return BACKGROUND_IMAGES[idx]
}
